import type { FC, ReactNode } from 'react'
import type { PackageArt } from '@/types'
import type { LabelQuality } from '@/components/three/label-texture'

import { useState } from 'react'
import { cn } from '@/lib/utils'

import { useStage } from './stage-context'
import { BagView3D } from './three-loaders'
import { PackageFallback } from './package-fallback'

interface ProductStageProps {
    art: PackageArt
    hovered?: boolean
    className?: string
    quality?: LabelQuality
    cmsId?: string
}

/* Shows the 2D pouch right away and swaps in the live 3D package when ready */
export const ProductStage: FC<ProductStageProps> = ({ art, hovered = false, className, quality = 'medium', cmsId }): ReactNode => {
    const { status, reducedMotion } = useStage()
    const [ready, setReady] = useState(false)
    const use3d = status === 'loading' || status === 'ready'
    const showing3d = ready && status === 'ready'

    return (
        <div className={cn('relative', className)}>
            <PackageFallback
                art={art}
                cmsId={cmsId}
                className={cn(
                    'absolute inset-0 transition-[opacity,transform] duration-500',
                    showing3d ? 'opacity-0' : 'opacity-100',
                    !showing3d && hovered && 'scale-105'
                )}
            />

            {use3d && (
                <BagView3D
                    art={art}
                    hovered={hovered}
                    quality={quality}
                    reducedMotion={reducedMotion}
                    onReady={() => setReady(true)}
                    className='absolute inset-0'
                />
            )}
        </div>
    )
}
